import React, { useEffect, useState } from "react";
import SecureLS from "secure-ls";
import { encrypt } from "../../utils/cipher.js";
import "../Login/login.css";
import Footer from "../DashBoardLayout/Footer";
import { Button } from "@mui/material";
import TopBar from "../DashBoardLayout/TopBar";
import LoginBg from "../../images/Group 342829.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { setLoginEmail, setLoginPassword} from "../../reduxStore/loginReducer.js";
import Loader from "../utils/Loader/Loader";
import Otp from "../OTP/Otp";
import { useDispatch } from "react-redux";

const Login = () => {
  var ls = new SecureLS();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [otpStatus, setOtpStatus] = useState(false); 
  const dispatch = useDispatch();
  const loginHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);
    let userEmail = email == undefined ? " " : email.trim();
    userEmail = userEmail.toLowerCase();
    const payload = {
      email: userEmail,
      password: password,
    };
    let encryptedPayload = encrypt(payload);
    try {

      axios
        .post(`${process.env.REACT_APP_BACKEND_URL}/login`, {
          payload: encryptedPayload,
        })
        .then((res) => {
          if (
            res.data["message"] == "Login Successful" &&
            res.data["success"] == true
          ) {
            console.log("inside success");
            setEmail(email);
            setPassword(password);
            setOtpStatus(true);
            ls.set("loginToken", res.data.token);
            ls.set("pwdReset", res.data.passwordResetDays);
            dispatch(setLoginEmail(email));
            dispatch(setLoginPassword(password));
          } else if (!res.data["success"]) {
            //Wrong Password || Account Not Active || User Not Found
            Swal.fire({
              title: "Error",
              text: `${res?.data?.message}`,
              icon: "error",
              confirmButtonText: "Retry",
              confirmButtonColor: "#1C81C4",
              preConfirm: () => {
                window.location.reload();
              }
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          if (
            err.response?.data?.success === false &&
            err.response?.data?.forcedPasswordReset === true
          ) {
            Swal.fire({
              title: "Password Expired",
              text: "Please reset your password",
              icon: "error",
              confirmButtonColor: "#1d2c47",
              confirmButtonText: "Reset Now",
              customClass: {
                // icon: "no-border",
                confirmButton: "custom-padding no-focus",
              },
            }).then(function () {
              window.location = `${process.env.REACT_APP_IDM_URL}/ForgotPassword/`;
            });
          }
          else if (err?.response?.data?.success == false) {
            if (err.response.data.accountLocked) {
              Swal.fire({
                title: "Error",
                text: `${err.response.data.message}`,
                icon: "error",
                confirmButtonText: "OK",
                confirmButtonColor: "#1C81C4",
              });
            }
            else {
              Swal.fire({
                title: "Error",
                text: `${err.response.data.message}`,
                icon: "error",
                confirmButtonText: "Retry",
                confirmButtonColor: "#1C81C4",
                preConfirm: () => {
                  window.location.reload();
                }
              });
            }
          }
          else {
            console.log("Error in Login---", err);
            Swal.fire({
              title: "Error",
              text: `${err.response.data.message}`,
              icon: "error",
              confirmButtonText: "Retry",
              confirmButtonColor: "#1C81C4",
              preConfirm: () => {
                window.location.reload();
              }
            });
            throw err;
          }
          setIsLoading(false);
        });
    } catch (error) {
      console.log("Error in Login: ", error)
      Swal.fire({
        title: "Error",
        text: `Something Went Wrong`,
        icon: "error",
        confirmButtonText: "Retry",
        confirmButtonColor: "#1C81C4",
        preConfirm: () => {
          window.location.reload();
        }
      });
      setIsLoading(false);
    }

  };
  const EntraLogin = () => {
    const data = {
      app: "nps",
      applicationUrl: `${process.env.REACT_APP_SSO_REDIRECT_URL}/redirect`,
    };

    const enData = encodeURIComponent(encrypt(data, process.env.REACT_APP_SSO_ENCRYPTION_KEY));
    window.open(`${process.env.REACT_APP_IDM_URL}/appLogin?Session=${enData}`, '_self');

  };

  return (
    <>
      {otpStatus == false ? (
        <div className="Login" style={{ margin: "4.25rem 0 0 0" }}>
          <TopBar />
          <form onSubmit={loginHandler}>
            <div className="LoginBody">
              <div className="LoginBody_one">
                <p className="welcomeHeader"
                  style={{
                    color: "#1C81C4",
                    fontWeight: "600",
                    fontSize: "1.4rem",
                    textAlign: "center",
                    marginBottom: "2rem",
                  }}
                >
                  Welcome to KFintech
                </p>

                <div className="OuterInput">
                  <div className="inputfields">
                    <p>UserName</p>
                    <input
                      placeholder="Enter User Name"
                      type="text"
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="inputfields">
                    <p>Password</p>
                    <input
                      placeholder="Enter password"
                      type="password"
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>

                  <Button
                    className="login-btn"
                    disabled={isLoading}
                    variant="outlined"
                    type="submit"
                    sx={{
                      color: `${isLoading ? "#000 !important" : "#1C81C4"}`,
                    }}
                  >
                    {isLoading ? "Logging In..." : "Login"}
                    {isLoading && <Loader color="#000" />}
                  </Button>
                </div>

                <p className="forgotPassword"
                  style={{
                    fontWeight: "bold",
                    color: "#484848",
                    textAlign: "center",
                    marginTop: "0.6rem",
                    // fontSize: "13px",
                  }}
                >
                  Forgot Password?{" "}
                  <a
                    style={{ textDecoration: "none", color: "#1C81C4" }}
                    href={`${process.env.REACT_APP_IDM_URL}/ForgotPassword/`}
                    target="_blank"
                  >
                    Reset Now
                  </a>
                </p>

                <p
                  className="resetPassword"
                  style={{
                    fontWeight: "bold",
                    color: "#484848",
                    textAlign: "center",
                    marginTop: "0.6rem",
                    marginBottom: "1rem",
                    // fontSize: "13px",
                  }}
                >
                  Don't have an account?
                  <a
                    to="/signup"
                    style={{ textDecoration: "none", color: "#1C81C4" }}
                    href={`${process.env.REACT_APP_IDM_URL}/`}
                    target="_blank"
                  >
                    &nbsp;Register Here
                  </a>
                </p>
                <div className="Entra">
                  <p className="lineText">OR</p>
                  <Button
                    className="Entra-btn"
                    disabled={isLoading}
                    variant="outlined"
                    sx={{
                      color: `${isLoading ? "#000 !important" : "#1C81C4"}`,
                    }}
                    onClick={EntraLogin}
                  >
                    Login With Entra ID
                    {/* {isLoading && <Loader color="#000" />} */}
                  </Button>
                </div>
              </div>

              <hr
                style={{
                  height: "45rem",
                  marginTop: "1rem",
                  color: "rgb(158, 154, 154)",
                  opacity: "0.4",
                  border: "1px solid rgb(158, 154, 154)",
                }}
                className="line"
              ></hr>

              <div className="LoginBody_two">
                <img src={LoginBg} alt="loginBackground"></img>
              </div>
            </div>
          </form>

          <div style={{ marginTop: "0.8rem" }}>
            <Footer />
          </div>
        </div>
      ) : (
        <Otp />
      )}
    </>
  );
};

export default Login;
